import styled from 'styled-components';

const colors = require('common/lib/colors/colors.less');

export const ReplyLink = styled.a`
  background-color: ${colors.N30};
  color: ${colors.N100}
  display: block;
  text-decoration: none;
  transition: 50ms background-color;

  &:hover {
    background-color: ${colors.N40A}
  }
`;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-detail/ReplyLink.js